import * as entities from 'entities';
import { TreatmentCategoryOutput } from 'js/model/rainbow/TreatmentCategoryOutput';

export function sortValues(
  a: TreatmentCategoryOutput,
  b: TreatmentCategoryOutput
): number {
  if (!a.normalisedName || !b.normalisedName) {
    return 0;
  }

  if (a.normalisedName < b.normalisedName) {
    return -1;
  }

  if (a.normalisedName > b.normalisedName) {
    return 1;
  }

  return 0;
}

export function decodeHtmlEntities(str: string): string {
  // regex matches & + any combo of letters or digits + ;
  // also matches &# + any number of digits + ;

  // choosing to only replace the most commonly used entities.
  // However, there are entities do not terminate in ;
  // the only fool proof method would be to test for these as well.
  // https://html.spec.whatwg.org/multipage/syntax.html#named-character-references
  return str.replace(/(&(\w+|\d+);|&#(\d+);)/g, (match, dec) =>
    entities.decodeHTML(dec)
  );
}
